__turbopack_context__.v({
  "align__center": "RichTextBlok-module__iXOnuW__align__center",
  "align__full": "RichTextBlok-module__iXOnuW__align__full",
  "align__left": "RichTextBlok-module__iXOnuW__align__left",
  "align__right": "RichTextBlok-module__iXOnuW__align__right",
  "blok-big-title": "RichTextBlok-module__iXOnuW__blok-big-title",
  "blok-subtitle": "RichTextBlok-module__iXOnuW__blok-subtitle",
  "blok-title": "RichTextBlok-module__iXOnuW__blok-title",
  "container": "RichTextBlok-module__iXOnuW__container",
  "ordered__list": "RichTextBlok-module__iXOnuW__ordered__list",
  "unordered__list": "RichTextBlok-module__iXOnuW__unordered__list",
});
